import moment from "moment"
import React from "react"
import { useDispatch } from "react-redux"
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap"
import AttendanceAction from "store/attendance-resource/actions"

const ModalDeleteStamp = ({ isModal, setIsModal, payload, cancel }) => {
  const toggle = () => setIsModal(false)
  const dispatch = useDispatch()

  const deleteStamp = () => {
    dispatch(
      AttendanceAction.deleteData(
        {
          date: moment(payload.date).format("YYYY-MM-DD"),
          staffId: payload?.staffId,
        },
        cancel
      )
    )
  }

  return (
    <Modal isOpen={isModal} toggle={toggle} className="modal-md" centered>
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody>
        <Row className="justify-content-center">
          <Col sm="12">
            <h4 className="text-center">打刻データを削除しますか?</h4>
          </Col>
          <Col sm="12" className="d-flex justify-content-center gap-4">
            <Button color="primary" onClick={deleteStamp}>
              はい
            </Button>
            <Button color="secondary" onClick={toggle}>
              いいえ
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default ModalDeleteStamp
